import { render, staticRenderFns } from "./PapersView.vue?vue&type=template&id=617a1414&scoped=true&"
import script from "./PapersView.vue?vue&type=script&lang=js&"
export * from "./PapersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a1414",
  null
  
)

export default component.exports